export default __webpack_public_path__ + "static/079-9f184f797433c4cd6db6b777ee120a7e.jpg";